import { useMemo } from 'react';
import { TimezoneDate } from '../../types';
import { useTimezone } from '../useTimezone';

/**
 * Parses a date in the given timezone
 * @param date
 * @param timezone IANA timezone identifier e.g. Europe/London https://www.iana.org/time-zones https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
 * @returns
 */
export const useTimezoneDate = (date: Date, timezone: string): TimezoneDate => {
    const { parseDate } = useTimezone(timezone);
    const parsedDate = useMemo(() => {
        return parseDate(date);
    }, [parseDate, date]);
    return parsedDate;
};
